export enum WidgetType {
  CHAT = "chat",
  CALL = "call",
}
export type WidgetSetting = {
  widget_type: WidgetType;
  fe_style: string;
};

export type Widget = {
  name: string;
  widget_settings: WidgetSetting[];
  logo_url: string;
  logo_id: string | null;
  fe_script: string | null;
  show_agent_name: boolean;
  greeting: string;
  site_url: string | null;
  brand_color: string | null;
  predefined_questions: string[];
  enable_predefined_questions: boolean;
  // enable_questions_suggestions: boolean;
};

export type WidgetColorPalette = {
  "chat-header--background-start-color": string;
  "chat-header--background-end-color": string;
  "chat-header--title-color": string;
  "chat-window--background-color": string;
  "chat-window--font-color": string;
  "send-button--background-color": string;
  "send-button--font-color": string;
  "chat--border-color": string;
  "chat-toggle-button--background-color": string;
  "chat-toggle-button--color": string;
};
